/**
 * @file CreditTipp.js
 * this is a simplified copy of credit.js limitted to the fields needed for role Tippgeber
 */
import React, { useContext, useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import axios from 'axios';
import {
	Typography,
	Button,
	IconButton,
	Paper,
	Grid,
	AppBar,
	Tabs,
	Tab,
	Toolbar,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	CircularProgress
} from "@material-ui/core";

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";
import CreditField from "./CreditField";
import CircularProgressWithLabel from "../general/CircularProgressWithLabel";
import { areArraysIdentical } from "../../functions/GlobalHelpers"
import { useCreditFunctions } from "../../functions/CreditFunctions";
import CreditFieldGroupPersonTipp from "./tippgeber/CreditFieldGroupPersonTipp";
import LiegenschaftChecklistDialog from "./tools/LiegenschaftChecklistDialog";
import AssignAgentDialog from "./tools/AssignAgentDialog";
import Alert from "@material-ui/lab/Alert";

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 1100,
		marginLeft: "auto",
		marginRight: "auto",
		zIndex: 1,
		position: "relative"
	},
	heading: {
		top: 60,
		paddingLeft: 0,
		paddingRight: 0,
		zIndex: 2,
	},
	headingspacer: {
		paddingTop: theme.spacing(2),
		marginLeft: theme.spacing(-2),
		marginRight: theme.spacing(-2),
		marginBottom: theme.spacing(-3),
		height: theme.spacing(7),
		width: "calc(100% + " + theme.spacing(4) + "px)",
		zIndex: 0
	},
	descriptionPaper: theme.descriptionPaper,
	accordionDetailsWithTabs: {
		display: "block"
	},
	progress: theme.progress
}));

const channelDisplayNames = {
	GLOBAL: "Allgemein",
	BAWAG: "BAWAG PSK",
	START: "Start:Bausparkasse",
	BANKAUSTRIA: "Bank Austria",
	BANKAUSTRIAAPI: "Bank Austria API",
	ING: "Bank99",
	EXCEL: "Excel Export",
};

export default function CreditTipp({ id, view }) {
	const theme = useTheme();
	const classes = useStyles();
	let history = useHistory();
	const [credit, setCredit] = useState({});
	const [portals, setPortals] = useState([]);
	const [loading, setLoading] = useState(false);
	const [channels, setChannels] = useState([]);
	const [metafields, setMetafields] = useState([]);
	// die configs aus den channels
	const [fieldConfigsByMetaKey, setFieldConfigsByMetaKey] = useState({});
	// die Metafield Objekte gruppiert nach meta_key
	const [fieldsByMetaKey, setFieldsByMetaKey] = useState({});
	const [metafieldsSaveTimeouts, setMetafieldsSaveTimeouts] = useState({});
	const [activeTabLiegenschaft, setActiveTabLiegenschaft] = useState(0);
	const [activeTabPerson, setActiveTabPerson] = useState(0);
	const [hasMakler, setHasMakler] = useState(false);
	const [hasSanierungskosten, setHasSanierungskosten] = useState(false);

	const pageContext = useContext(PageContext);
	const userContext = useContext(UserContext);

	useEffect(() => {
		if (id && (!credit || !credit.id || credit.id !== id)) {
			getCredit();
			setLoading(true);
		} else if (!id) {
			setCredit({});
			setChannels([]);
			setMetafields([]);
		}
	}, [id]);


	useEffect(() => {
		setFieldsByMetaKey(newFieldsByMetaKey => {
			const isFirstRun = Object.keys(newFieldsByMetaKey).length === 0;
			metafields.forEach(field => {
				if (field.meta_key in newFieldsByMetaKey) {
					const existingFieldIndex = newFieldsByMetaKey[field.meta_key].findIndex(f => f.id === field.id);
					if (existingFieldIndex > -1) {
						if (newFieldsByMetaKey[field.meta_key][existingFieldIndex].meta_value !== field.meta_value
							|| newFieldsByMetaKey[field.meta_key][existingFieldIndex].meta_value_numeric !== field.meta_value_numeric
							|| newFieldsByMetaKey[field.meta_key][existingFieldIndex].meta_value_boolean !== field.meta_value_boolean
							|| newFieldsByMetaKey[field.meta_key][existingFieldIndex].file_document_type !== field.file_document_type
						)
							newFieldsByMetaKey[field.meta_key][existingFieldIndex] = field;
					} else {
						newFieldsByMetaKey[field.meta_key].push(field);
					}
				} else {
					newFieldsByMetaKey[field.meta_key] = [field];
				}
			});
			// Wenn das Objekt zum ersten mal befüllt wird möchte ich, dass dies ein Re-Render ausführt, ansonsten nicht.
			return isFirstRun ? { ...newFieldsByMetaKey } : newFieldsByMetaKey;
		});


		setFieldConfigsByMetaKey(newFieldConfigs => {
			const isFirstRun = Object.keys(newFieldConfigs).length === 0;
			let hasChanged = false;
			metafields.forEach(field => {
				const fieldConfigs = creditFunctions.getConfigsForField(field.meta_key, true, true);
				// prüft ob die configs bereits vorhanden sind und gleich lang sind
				// gleich lang spielt eine Rolle wenn ein Feld (oder eine config eines Feldes) aufgrund von Conditions ein- oder ausgeblendet wird
				if (field.meta_key in newFieldConfigs && newFieldConfigs[field.meta_key].length === fieldConfigs.length) {
					// hier können sich eigentlich nur mehr die Channels ändern. 
					// einer könnte aus- oder eingeblendet werden
					if (newFieldConfigs[field.meta_key].some((existingConfig, i) => {
						return !areArraysIdentical(existingConfig.channels, fieldConfigs[i].channels)
					})) {
						newFieldConfigs[field.meta_key] = fieldConfigs;
						hasChanged = true;
					}
				} else {
					newFieldConfigs[field.meta_key] = fieldConfigs;
					hasChanged = true;
				}
			});
			// Wenn das Objekt zum ersten mal befüllt wird möchte ich, dass dies ein Re-Render ausführt, ansonsten nicht.
			return (isFirstRun || hasChanged) ? { ...newFieldConfigs } : newFieldConfigs;
			//return isFirstRun ? {...newFieldConfigs} : newFieldConfigs;
		})
	}, [metafields, channels]);

	useEffect(() => {
		if (loading && credit && credit.id && Object.keys(fieldConfigsByMetaKey).length > 0 && Object.keys(fieldsByMetaKey).length > 0)
			setLoading(false);
	}, [loading, credit, fieldConfigsByMetaKey, fieldsByMetaKey]);

	const getCredit = (action = null, action_param = null) => {
		let url = `${process.env.REACT_APP_API_SERVICE_URL}/credits/${id}`;
		if (action) {
			url += "/" + action;
			if (action_param)
				url += "/" + action_param;
		}
		const options = {
			url: url,
			method: 'get',
			headers: userContext.getRequestAuthHeader(),
			//timeout: 40000 // timout after 40 seconds
		};
		axios(options)
			.then((res) => {
				const newCredit = { ...res.data };
				// verbundene Objekte entfernen und separat im State speichern
				delete newCredit.channels;
				delete newCredit.metafields;
				setCredit(newCredit);
				let newChannels = [];
				// sort channels by channelDisplayname list
				res.data.channels.forEach(channel => {
					const channel_index = Object.keys(channelDisplayNames).indexOf(channel.channel_shortname);
					newChannels[channel_index] = channel;
				});
				// remove empty indexes from array
				newChannels = newChannels.filter(channel => channel !== undefined);

				setChannels(newChannels);
				setMetafields(res.data.metafields);
				getPortals();
			})
			.catch((err) => {
				// if (err.response && err.response.code === "ECONNABORTED") {
				// 	// retry
				// 	console.log('retry');
				// 	getCredit(action, action_param);
				// }
				console.log(err);
			});
	}

	const getPortals = () => {
		let url = `${process.env.REACT_APP_API_SERVICE_URL}/portals/${id}`;
		const options = {
			url: url,
			method: 'get',
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then((res) => {
				setPortals(res.data);
			})
			.catch((err) => {
				console.log(err);
			});
	}

	const createPortal = (personIndex, portalPin = "", callback = null) => {
		let url = `${process.env.REACT_APP_API_SERVICE_URL}/portals/${id}`;
		const options = {
			url: url,
			data: {
				person_index: personIndex,
				portal_pin: portalPin,
			},
			method: 'post',
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then((res) => {
				getPortals();
				if (callback)
					callback();
			})
			.catch((err) => {
				console.log(err);
			});
	}


	const savePortal = (portal, callback = null) => {
		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/portals/${credit.id}/${portal.id}`,
			method: 'put',
			data: portal,
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then((res) => {
				getPortals();
				if (callback)
					callback();
			})
			.catch((err) => {
				console.log(err);
				pageContext.setErrorMessage("Die Änderung für das Kundenportal konnte nicht gespeichert werden!");
			});
	}


	const saveCredit = (silent) => {
		const saveData = { ...credit, channels: [] };
		channels.forEach(channel => {
			saveData.channels.push({ id: channel.id, enabled: channel.enabled });
		});
		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/credits/${credit.id}`,
			method: 'put',
			data: saveData,
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then((res) => {
				if (!silent)
					pageContext.setInfoMessage("Finanzierung wurde gespeichert");
			})
			.catch((err) => {
				console.log(err);
				if (!silent)
					pageContext.setErrorMessage("Finanzierung konnte nicht gespeichert werden!");
			});
	}


	useEffect(() => {
		if (!loading && credit && credit.id && channels)
			saveCredit(true);
	}, [channels]);




	const getMetafieldsByFieldConfig = (fieldConfig) => {
		return metafields.filter(field => field.meta_key === fieldConfig.meta_key && fieldConfig.channels.includes(field.channel));
	}



	const setMetafieldsValues = (currentMetafields, value, forceRerender = false) => {
		setMetafields(fields => {
			let updatedIDs = [];
			currentMetafields.forEach(metafield => {
				fields = creditFunctions.setMetafieldValue(fields, metafield, value);

				updatedIDs.push(metafield.id);
			})

			if (forceRerender)
				return [...fields];
			return fields;
		})
	}

	const isFieldVisible = (fieldConfig) => {
		return true;
	}

	const creditFunctions = useCreditFunctions(
		channels,
		setMetafieldsValues,
		metafieldsSaveTimeouts,
		setMetafieldsSaveTimeouts,
		pageContext,
		userContext,
		getMetafieldsByFieldConfig,
		isFieldVisible,
	);






	const renderCreditField = (meta_key, xs = 12, md = 12, fieldlayout = "") => {
		return <CreditField
			setMetafieldsValues={setMetafieldsValues}
			resolvePlaceholders={creditFunctions.resolvePlaceholders}
			channelDisplayNames={channelDisplayNames}
			metafieldsForCurrentMetaKey={fieldsByMetaKey[meta_key]}
			fieldConfigs={fieldConfigsByMetaKey[meta_key]}
			meta_key={meta_key}
			xs={xs}
			md={md}
			fieldlayout={fieldlayout}
			credit={credit}
		/>
	}

	if (!credit || loading)
		return <>
			<CircularProgress
				className={classes.progress}
				color="secondary"
			/>
		</>;


	return (
		<>
			<AppBar
				position="fixed"
				className={classes.heading}
				color="primary"
				elevation={0}
			>
				<Typography align="center" variant="h3">Finanzierung – {credit.title}</Typography>
			</AppBar>
			<AppBar
				position="relative"
				className={classes.headingspacer}
				color="primary"
				elevation={0}
				align="left"
			>
				<Toolbar variant="dense">
					<IconButton
						color="inherit"
						onClick={() => {
							history.push("/finanzierungen/");
						}}>
						<ArrowBackIcon />
					</IconButton>
				</Toolbar>
			</AppBar>
			<div className={classes.root}>

				<Paper className={classes.descriptionPaper}>
					<Typography variant="h5">Kreditnehmer</Typography>
					<br /><br />
					<AppBar position="static" color="default">
						<Tabs
							value={activeTabPerson}
							indicatorColor="primary"
							textColor="primary"
							onChange={(e, value) => {
								setActiveTabPerson(value);
							}}
						>
							{[0, 1, 2, 3].map(index => {
								let tabLabel = creditFunctions.resolvePlaceholders("[__person" + (index + 1) + "__vorname] [__person" + (index + 1) + "__nachname]");
								if (tabLabel.length < 5)
									tabLabel = "Kreditnehmer " + (index + 1);
								return (
									<Tab
										label={tabLabel}
										key={index}
										icon={
											<CircularProgressWithLabel percent={creditFunctions.getFieldGroupProgress("person_tipp", index + 1)} />
										}
									/>
								)
							})
							}
						</Tabs>
					</AppBar>
					<br />
					{[0, 1, 2, 3].map(index => {
						if (activeTabPerson === index)
							return (
								<Grid container spacing={4} role="tabpanel" key={index}>
									<CreditFieldGroupPersonTipp
										renderCreditField={renderCreditField}
										creditFunctions={creditFunctions}
										createPortal={createPortal}
										savePortal={savePortal}
										portals={portals}
										index={index + 1}
										credit_id={id}
										metafields={metafields}
										setMetafields={setMetafields}
									/>
								</Grid>
							);
					})
					}
				</Paper>
				{credit.type === "hypothekar" &&
					<Paper className={classes.descriptionPaper}>
						<Grid container spacing={4}>
							<Grid item xs={12}>
								<Typography variant="h5">Kosten</Typography>
							</Grid>

							{credit.subtype && ["hauskauf", "wohnungskauf", "grundkauf"].includes(credit.subtype) &&
								<>
									{renderCreditField("kaufpreis", 12, 7, "pricetable")}
									<Grid item xs={12} md={7}>
										<Grid container spacing={4}>
											<Grid item>
												<Typography>Wird der Kauf über einen Makler abgewickelt?</Typography>
											</Grid>
											<Grid item>
												<Button
													variant={hasMakler ? "contained" : "outlined"}
													size="small"
													onClick={() => {
														setHasMakler(true);
													}}>
													Ja
												</Button>
											</Grid>
											<Grid item>
												<Button
													variant={hasMakler ? "outlined" : "contained"}
													size="small"
													onClick={() => {
														setHasMakler(false);
														setMetafieldsValues(fieldsByMetaKey["makler"], 0);
													}}>
													Nein
												</Button>
											</Grid>
										</Grid>
									</Grid>
									{hasMakler && renderCreditField("makler", 12, 5, "pricetable")}
								</>
							}
							{credit.subtype && ["hauskauf", "wohnungskauf", "grundkauf", "umschuldung"].includes(credit.subtype) &&
								<>
									<Grid item xs={12} md={7}>
										<Grid container spacing={4}>
											<Grid item>
												<Typography>Gibt es zusätzliche Sanierungskosten?</Typography>
											</Grid>
											<Grid item>
												<Button
													variant={hasSanierungskosten ? "contained" : "outlined"}
													size="small"
													onClick={() => {
														setHasSanierungskosten(true);
													}}>
													Ja
												</Button>
											</Grid>
											<Grid item>
												<Button
													variant={hasSanierungskosten ? "outlined" : "contained"}
													size="small"
													onClick={() => {
														setHasSanierungskosten(false);
														setMetafieldsValues(fieldsByMetaKey["sanierungskosten"], 0);
													}}>
													Nein
												</Button>
											</Grid>
										</Grid>
									</Grid>
									{hasSanierungskosten && renderCreditField("sanierungskosten", 12, 5, "pricetable")}
								</>
							}
							{credit.subtype && ["hausbau", "umbau"].includes(credit.subtype) &&
								<>
									<Grid item xs={12}></Grid>
									{renderCreditField("bau_umbaukosten", 12, 7, "pricetable")}
								</>
							}
							{credit.subtype && ["hauskauf", "wohnungskauf", "grundkauf", "hausbau", "umbau"].includes(credit.subtype) &&
								<>
									{renderCreditField("eigenmittel", 12, 7, "pricetable")}
									{renderCreditField("eigenmittelreserve", 12, 7, "pricetable")}
									<Grid item xs={12}>
										<Typography variant="caption">
											Wenn keine Eigenmittel vorhanden, dann Feld bitte mit 0 befüllen.
										</Typography>
									</Grid>
								</>
							}
						</Grid>
					</Paper>
				}
				{credit.type === "hypothekar" &&
					<Paper className={classes.descriptionPaper}>
						<Typography variant="h5">Liegenschaften</Typography>
						<br /><br />
						<AppBar position="static" color="default">
							<Tabs
								value={activeTabLiegenschaft}
								indicatorColor="primary"
								textColor="primary"
								onChange={(e, value) => {
									setActiveTabLiegenschaft(value);
								}}
							>{[0, 1, 2].map(index =>
								<Tab
									label={<><div>Liegenschaft {(index + 1)}</div><div>{(index === 0 ? " Finanzierungsobjekt" : " Sicherheit")}</div></>}
									key={index}
									icon={
										<CircularProgressWithLabel percent={creditFunctions.getFieldGroupProgress("liegenschaft_tipp", index + 1)} />
									}
								/>)}
							</Tabs>
						</AppBar>
						<br />

						{[0, 1, 2].map(index => {
							if (activeTabLiegenschaft === index)
								return (
									<Grid container spacing={4} role="tabpanel" key={index} alignItems="flex-end">
										{renderCreditField("objektdaten_liegenschaft" + (index + 1) + "_objekt", 12, 6)}
										<Grid item xs={12} md={6} >
											<LiegenschaftChecklistDialog
												liegenschaftIndex={index + 1}
												portals={portals}
												credit_id={credit.id}
												metafields={metafields}
											/>
										</Grid>
									</Grid>
								);
						})
						}
					</Paper>
				}
				<br /><br />
				<Paper className={classes.descriptionPaper}>
					<Typography variant="h6">Kreditantrag an Finanzierungsberater übergeben</Typography>
					<br />
					<Typography variant="body1">
						Wenn du mit deinen Eingaben fertig bist, wähle bitte einen Finanzierungsberater, der die weitere Bearbeitung deines Antrags übernimmt.
					</Typography>
					<br />
					<AssignAgentDialog
						credit={credit}
						creditFunctions={creditFunctions}
					/>
				</Paper>
				<br /><br />


				<Accordion TransitionProps={{ unmountOnExit: true }}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
					>
						<Typography variant="h5">Anleitung</Typography>
					</AccordionSummary>
					<AccordionDetails className={classes.accordionDetailsWithTabs}>
						<Grid container spacing={4} role="tabpanel">
							<Grid item xs={12}>
								<Typography variant="h6">1. Kontaktdaten Kreditnehmer</Typography>
								<Typography variant="body2">Bitte fülle für alle Kreditnehmerinnern und Kreditnehmer die Kontaktdaten aus.</Typography>
							</Grid>
							<Grid item xs={12}>
								<Typography variant="h6">2. Kundenportal</Typography>
								<Typography variant="body2">Erstelle für jeden Kreditnehmer ein Kundenportal. Damit bekommt die Person sofort einen Link zugesendet über den sie die restlichen persönlichen Daten ergänzen kann. Das können die Kreditnehmer auch gleich vor Ort am Smartphone erledigen oder aber innerhalb von 3 Tagen auch noch nach dem Termin.</Typography>
							</Grid>
							<Grid item xs={12}>
								<Typography variant="h6">3. Dokumente</Typography>
								<Typography variant="body2">
									Klicke nochmal auf die Kundenportale, scrolle ein Stück hinunter zu den Dokument-Vorlagen und klicke dann bei Datenschutzererklärung und Standardinformation auf "Unterschrift anfordern".<br />
									Die beiden Seiten des Dokuments müssen dann von den Kreditnehmern direkt im Kundenportal unterschrieben werden.
								</Typography>
							</Grid>
							<Grid item xs={12}>
								<Typography variant="h6">4. Liegenschaften (bei Hypothekarkrediten)</Typography>
								<Typography variant="body2">
									Erstelle für jede Liegenschaft eine Checkliste und fülle diese gemeinsam mit den Kreditnehmern aus.<br />
									Die Checkliste steht dann auch dem Kunden wieder im Portal zur Verfügung. Dort kann sie nochmal kontrolliert, geändert aber vor allem unterschrieben werden.<br />
									<Alert severity="info">Bitte schließe den Browser-Tab mit der Checkliste nach der Bearbeitung, solange du die Checkliste nämlich geöffnet hast kann der Kunde sie nicht öffnen um sie zu unterschreiben.</Alert>
								</Typography>
							</Grid>
							<Grid item xs={12}>
								<Typography variant="h6">5. Übergabe an Finanzierungsberater</Typography>
								<Typography variant="body2">
									Sobald du alles ausgefüllt hast übergib den Kreditantrag bitte an einen Finanzierungsberater für die weitere Bearbeitung.<br />
									Klicke den entsprechenden Button und wähle einen Berater aus.
								</Typography>
							</Grid>
						</Grid>
					</AccordionDetails>
				</Accordion>
			</div>
		</>
	);
}
